// extracted by mini-css-extract-plugin
export default {"modal-container":"NewUserModal_modal-container__M4ejo"};